import React, { useMemo } from 'react';
import { useAppFilters } from '../../shared';
import { ASSETS_TYPE } from '@/types/shared/navigation-tabs.enums';
import { sortComponentsByHealthStatusAndName } from '@/components/pages/AssetsStudioPage/SidePane/ComponentSelector/util';
import { useFilteredList } from './useFilteredList';

// const HEALTH_STATUS_SCORE = {
//   critical: 5,
//   alarm: 4,
//   monitor: 3,
//   healthy: 2,
//   na: 1,
// };

// const sortAssetsByStatusCode = (assets: any[]) => {
//   if (!assets || assets.length === 0) return [];
//   return assets.sort((a, b) => {
//     // Sort by health_status using the HEALTH_STATUS_SCORE
//     if (a.health_status && b.health_status) {
//       const tmpA = a.not_monitored ? 'na' : a.health_status;
//       const tmpB = b.not_monitored ? 'na' : b.health_status;
//       const statusDiff =
//         HEALTH_STATUS_SCORE[tmpB.toLowerCase() as 'critical'] - HEALTH_STATUS_SCORE[tmpA.toLowerCase() as 'critical'];
//       if (statusDiff !== 0) return statusDiff;
//     }
//     // If health_status is the same (=0), sort alphabetically
//     return a.asset_ui_name.localeCompare(b.asset_ui_name);
//     //@todo - add handler for na
//   });
// };

export function useAssetsData(assets: any[] | undefined) {
  const { assetsType } = useAppFilters();
  // Mobile-specific search
  const filteredAssets = useFilteredList(
    assets,
    ['asset_ui_name', 'asset_name'], // keys to search
    (asset, searchValue) => {
      const lowerSearch = searchValue.toLowerCase();
      if (assetsType === 'mobile' && searchValue.length > 0) {
        return (
          asset.asset_ui_name.toLowerCase().includes(lowerSearch) ||
          asset.asset_name.toLowerCase().includes(lowerSearch)
        );
      }
      return asset.asset_ui_name.toLowerCase().includes(lowerSearch);
    }
  );

  const { required, notRequired } = useMemo(() => {
    const requiredStatuses = ['critical', 'alarm'];
    const requiredItems = filteredAssets.filter((a) => requiredStatuses.includes(a.health_status));
    const notRequiredItems = filteredAssets.filter((a) => !requiredStatuses.includes(a.health_status));

    return {
      required: {
        fixed: sortComponentsByHealthStatusAndName(
          requiredItems.filter((a) => a.asset_category !== 'mobile'),
          'asset_ui_name'
        ),
        mobile: sortComponentsByHealthStatusAndName(
          requiredItems.filter((a) => a.asset_category === 'mobile'),
          'asset_ui_name'
        ),
      },
      notRequired: {
        fixed: sortComponentsByHealthStatusAndName(
          notRequiredItems.filter((a) => a.asset_category !== 'mobile'),
          'asset_ui_name'
        ),
        mobile: sortComponentsByHealthStatusAndName(
          notRequiredItems.filter((a) => a.asset_category === 'mobile'),
          'asset_ui_name'
        ),
      },
    };
  }, [filteredAssets]);

  return { required, notRequired };
}
